import { projects } from "./projects";
import "./App.css";

function App() {
  return (
    <div className="lg:flex body sm:flow-root ml-2">
      <div className="details sm:ml-6">
        <h1 className="mb-2">Deep Roop</h1>
        <h2 className="mb-8 text-2xl">Frontend Developer</h2>
        <p className="mb-8 leading-8" style={{ width: "243px" }}>
          <strong className="font-semibold">Skills:</strong> HTML, CSS,
          JavaScript, ReactJs, PrimeReact, Tailwind CSS,
          Bootstrap, GIT, Java, SQL.
        </p>
        <div className="flex mb-8">
          <a href="https://www.linkedin.com/in/deep-roop/">
            <i className="fa-brands fa-linkedin-in fa-xl pr-4"></i>
          </a>
          {/* <a href="https://twitter.com/Deeproop1">
            <i className="fa-brands fa-twitter fa-xl pr-5"></i>
          </a> */}
          <a href="mailto:deepsinghroop@gmail.com">
            <i className="fa-solid fa-envelope fa-xl pr-6"></i>
          </a>
          <a href="https://github.com/deeproop">
            <i class="fa-brands fa-github fa-xl"></i>
          </a>
        </div>
        <a
          className="text-2xl"
          href="https://drive.google.com/file/d/1Mpi8v3cR3NM6bJ3ywyHHIIjG9FRJ4fqe/view?usp=share_link"
        >
          Resume
        </a>
      </div>
      <div className="projects">
        <h1 className="lg:text-center md:text-left mr-20 pr-20">Projects</h1>
        <div className="lg:flex flex-wrap">
          {projects.map((project) => (
            <a href={project.url}>
              <div className="card">
                <div className="card_image">
                  <img src={project.image} />
                </div>
                <div className="card_title">
                  <p>{project.name}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;

{
  /* <div className="cards-list">
  
  <div className="card 1">
    <div className="card_image"> <img src={project.image} /> </div>
    <div className="card_title title-white">
      <p>{project.name}</p>
    </div>
  </div>
  </div> */
}
